import { LeadNewness } from '../../api/models';
import {
  createAction,
  createActionWithPayload,
  IAction,
  IActionWithPayload,
} from '../utils';

const ACTION_LOAD_NEWNESS_REQUEST = 'ENTITIES/LOAD_NEWNESS_REQUEST';
const ACTION_LOAD_NEWNESS_SUCCESS = 'INTENT/LOAD_NEWNESS_SUCCESS';
const ACTION_LOAD_NEWNESS_ERROR = 'INTENT/LOAD_NEWNESS_ERROR';

export interface LeadNewnessState {
  leadNewness: LeadNewness[];
  isLoading?: boolean;
  isLoaded?: boolean;
}

const initialState: LeadNewnessState = {
  leadNewness: [],
  isLoaded: false,
  isLoading: false,
};

type LeadNewnessRequestActionType = IAction<typeof ACTION_LOAD_NEWNESS_REQUEST>;

type LeadNewnessSuccessActionType = IActionWithPayload<
  typeof ACTION_LOAD_NEWNESS_SUCCESS,
  LeadNewness[]
>;

type LeadNewnessErrorActionType = IAction<typeof ACTION_LOAD_NEWNESS_ERROR>;

type Actions =
  | LeadNewnessRequestActionType
  | LeadNewnessSuccessActionType
  | LeadNewnessErrorActionType;

export const loadNewnessRequestAction = (): LeadNewnessRequestActionType => {
  return createAction(ACTION_LOAD_NEWNESS_REQUEST);
};

export const loadNewnessSuccessAction = (
  data: LeadNewness[]
): LeadNewnessSuccessActionType => {
  return createActionWithPayload(ACTION_LOAD_NEWNESS_SUCCESS, data);
};

export const loadNewnessErrorAction = (): LeadNewnessErrorActionType => {
  return createAction(ACTION_LOAD_NEWNESS_ERROR);
};

// reducer
export const leadNewnessReducer = (
  state: LeadNewnessState = initialState,
  action: Actions
): LeadNewnessState => {
  switch (action.type) {
    case ACTION_LOAD_NEWNESS_REQUEST:
      return {
        ...state,
        isLoading: true,
        isLoaded: false,
      };
    case ACTION_LOAD_NEWNESS_ERROR:
      return {
        ...state,
        isLoaded: true,
        isLoading: false,
      };
    case ACTION_LOAD_NEWNESS_SUCCESS:
      return {
        ...state,
        leadNewness: action.payload,
        isLoading: false,
        isLoaded: true,
      };
    default:
      return state;
  }
};
